import React, {FC} from 'react';

import {ChannelModel} from '../../../../libs/shared/core/src/models/api/channelModel';
import {MassArchiveDialogContainer} from './massArchiveDialogContainer';

/*
 * Props.
 */

interface MassArchiveDialogManagerProps {
  channel: ChannelModel | undefined;
}

/*
 * Component.
 */

export const MassArchiveDialogManager: FC<MassArchiveDialogManagerProps> = ({channel}) => {
  if (!channel) {
    return null;
  }

  return <MassArchiveDialogContainer key={channel.id} channel={channel} />;
};
